module.exports = __webpack_public_path__ + "img/LockIcon.41d40bfa.svg";